<template>
  <div class="relative">
    <ul
      class="gap-4"
      :class="[
        layout,
        layout === 'grid' && filter.options.length > 7
          ? filter.options.length > 14
            ? 'cols-3'
            : 'cols-2'
          : 'f-col',
      ]"
    >
      <li v-for="({ id, items, label }, i) in filter.options" :key="id + i">
        <vf-checkbox v-model="model" style="max-width: 13.625rem" :value="id">
          <span
            class="flex transform gap-1"
            :class="[isImageCheckbox ? 'items-center' : 'mt-0.5 -translate-x-1']"
          >
            <base-picture
              v-if="isImageCheckbox"
              :alt="label"
              :height
              :src="`/img/logos/${id}.svg`"
              :width
            />
            <span v-else class="line-clamp-3 text-sm">
              {{ label }}
            </span>
            <span class="mt-0.5 text-xs c-grey-20">
              ({{ items }})
            </span>
          </span>
        </vf-checkbox>
      </li>
    </ul>
    <div v-if="loading" class="absolute-0 bg-white op-50" />
  </div>
</template>

<script lang="ts" setup>
import type { CheckboxFilter } from '#types/filters'

const { filter, layout = 'flex' } = defineProps<{
  filter: CheckboxFilter
  layout?: 'flex' | 'grid'
  loading?: boolean
}>()

const model = defineModel<string[]>()

const { height, width } = useAppConfig().components.filter.option.checkbox.image

const isImageCheckbox = computed(() => filter.type === 'ImageCheckbox')
</script>
